import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import { POIAction } from '../Actions/Models/POIActionModel';
import * as PoiModel from './../../Models/POIModel';

export type State = PoiModel.Types.POIStore;

export const initialState: PoiModel.Types.POIStore = {
    poiList: [],
    activePoi: null,
    poiDetailsPopupVisible: false,
    addPoiPopupPosition: null
};

export function poiReducer(state: PoiModel.Types.POIStore = initialState, action: POIAction): State {
    switch (action.type) {
        case ActionTypes.POI.GET_POI_SUCCESS: {
            return {
                ...state,
                poiList: action.payload.poiList
            };
        }
        // case ActionTypes.POI.GET_POI_FAILURE:
        // case ActionTypes.POI.UPDATE_POI_SUCCESS:
        // case ActionTypes.POI.DELETE_POI_SUCCESS:
        // case ActionTypes.POI.ADD_POI_FAILURE:
        // case ActionTypes.POI.DELETE_POI_FAILURE:

        // case ActionTypes.POI.ADD_POI_SUCCESS: {
        //     return {
        //         ...state
        //     };
        // }
        // case ActionTypes.POI.ADD_POI_FAILURE: {
        //     return {
        //         ...state
        //     };
        // }
        // case ActionTypes.POI.DELETE_POI_FAILURE: {
        //     return {
        //         ...state,
        //     };
        // }
        case ActionTypes.POI.SET_DETAILS_FOR_POI_VIEW: {
            return {
                ...state,
                activePoi: action.payload.activePoi
            };
        }
        case ActionTypes.POI.POI_DETAILS_POPUP_SHOW: {
            return {
                ...state,
                poiDetailsPopupVisible: true
            };
        }
        case ActionTypes.POI.POI_DETAILS_POPUP_HIDE: {
            return {
                ...state,
                poiDetailsPopupVisible: false
            };
        }
        case ActionTypes.POI.POI_DETAILS_POPUP_TOGGLE: {
            return {
                ...state,
                poiDetailsPopupVisible: !state.poiDetailsPopupVisible
            };
        }
        case ActionTypes.POI.ADD_POI_POPUP_POSITION: {
            return {
                ...state,
                addPoiPopupPosition: action.payload.popupPosition
            };
        }
        case ActionTypes.POI.GET_POI_FAILURE:
        case ActionTypes.POI.UPDATE_POI_SUCCESS:
        case ActionTypes.POI.DELETE_POI_SUCCESS:
        case ActionTypes.POI.ADD_POI_FAILURE:
        case ActionTypes.POI.DELETE_POI_FAILURE:
        case ActionTypes.POI.ADD_POI_SUCCESS:
        default: {
            return {
                ...state
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/POIReducer.ts